import type { RouteObject } from 'react-router';

import { settingsIndexRoute } from './index/settings-index.route';
import { settingsServiceRoute } from './service/settings-service.route';

/**
 * The settings feature — an index and one page per service, aggregated.
 *
 * A multi-route feature exports a **plural** `.routes.tsx`, so the file name
 * alone tells the router what shape to expect at import time.
 *
 * The two share a URL segment and nothing else, so the parent carries `path`
 * and no `element`: a layout element here would draw chrome that the index and
 * the service page each already own, and the navigation column's single
 * `/settings` entry lands on the index either way.
 */
export const settingsRoutes: RouteObject[] = [
  {
    path: 'settings',
    children: [settingsIndexRoute, settingsServiceRoute],
  },
];
